import { USER_ROLES } from './Enum/RoleEnum';

/**
 * Role-based access control configuration
 * Define which roles can access which routes/features
 */

// Accessible roles for user routes (dashboard, practice, etc.)
export const USER_ROUTE_ACCESSIBLE_ROLES = [
    USER_ROLES.USER,
    USER_ROLES.ADMIN  // Admin can also access user routes
];

// Accessible roles for admin-only routes
export const ADMIN_ROUTE_ACCESSIBLE_ROLES = [
    USER_ROLES.ADMIN
];

// Feature-specific access control
export const FEATURE_ACCESS = {
    FEATURE_FLAGS: [USER_ROLES.ADMIN],
    USER_MANAGEMENT: [USER_ROLES.ADMIN],
    PRACTICE_MODE: [USER_ROLES.USER, USER_ROLES.ADMIN],
    DASHBOARD: [USER_ROLES.USER, USER_ROLES.ADMIN],
};
